//core
import React from "react";
import {IconButton} from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

interface ICollapse {
  open: boolean;
  setOpen: (state: boolean) => void;
}

const RowCollapse: React.FC<ICollapse> = ({
  open,
  setOpen,
}): JSX.Element  => {

  return (
    <IconButton
      aria-label="expand row"
      size="small"
      onClick={() => setOpen(!open)}
    >
      {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
    </IconButton>
  );
};

export default RowCollapse;
